import { create } from 'zustand';
import { Spritesheet } from 'pixi.js';
import { SpritesState } from '../types/store.types';

export type { SpritesState };

interface SpritesActions {
  setTextures: (t: { [key: string]: Spritesheet }) => void;
  addTextures: (t: { [key: string]: Spritesheet }) => void;
  setIsLoaded: (v: boolean) => void;
}

export const useSpritesStore = create<SpritesState & SpritesActions>((set) => ({
  textures: {},
  isLoaded: false,

  setTextures: (t) => set({ textures: t }),
  addTextures: (t) => set((s) => ({ textures: { ...s.textures, ...t } })),
  setIsLoaded: (v) => set({ isLoaded: v }),
}));
